import { ApiProperty } from '@nestjs/swagger';
import { ArrayNotEmpty, IsArray, IsUUID } from 'class-validator';

export class ReorderItemsDto {
  @ApiProperty({ type: [String], description: 'IDs de los ítems en el nuevo orden' })
  @IsArray()
  @ArrayNotEmpty()
  @IsUUID('all', { each: true })
  item_ids: string[];
}
